var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"side-panel d-block card bg-white shadow-sm w-100 h-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }